import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fromStore } from '../../../selectors';
import Loader from '../../../components/utils/Loader';
import InfoBox from '../../../components/utils/InfoBox';
import { isEmpty } from 'lodash';
import { formatDateTime } from '../../../utils/formatDateTime';
import { fetchGoods, setActiveModalAction } from '../../../action';
import swal from "sweetalert";
import { MEASURES_RAW } from '../../rawmaterials/constansts';
import { deleteReceipe } from '../../../action/recipes';
import { fetchRawsList, getRecipeSemiById } from '../../../action/raw';
import { parseNumToFixed } from '../../../utils/common';

const styles = {
    loading: {
        minHeight: '500px',
        display: 'flex',
        justifyContent: 'center'
    }
}

export function ReceipeSemi() {
    const dispatch = useDispatch();
    const detail = useSelector(fromStore.detailRawSelector);
    const loaderReceipe = useSelector(fromStore.loaderRecipeGoodSelector);
    const raws = useSelector(fromStore.rawListSelector);
    const goods = useSelector(fromStore.goodListSelector);
    const loaderList = useSelector(fromStore.loaderRawsSelector);
    const loaderListGood = useSelector(fromStore.loaderGoodsSelector);
    const loading = loaderReceipe || loaderList || loaderListGood;
    const [activeReceipe, setActiveReceipe] = useState(null);
    const id = detail ? detail.id : null;

    const recipeLoaded = detail && detail.recipes;

    useEffect(() => {
        if (id && !recipeLoaded) dispatch(getRecipeSemiById(id));
        if (recipeLoaded && recipeLoaded.length > 0) setActiveReceipe(detail.recipes[0]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, id, recipeLoaded]);

    useEffect(() => {
        if (isEmpty(raws)) dispatch(fetchRawsList());
        if (isEmpty(goods)) dispatch(fetchGoods());
    }, [dispatch, raws, goods]);


    const onOpenEditRecipe = (e) => {
        e.stopPropagation();
        dispatch(setActiveModalAction({ field: 'recipes', value: { data: activeReceipe, type: 'semi' }}));
    };

    const handleDelete = () => {
        swal({
            title: "Удаление рецепта",
            text: `Вы действительно хотите удалить рецепт за ${new Date(activeReceipe.startDate).toLocaleDateString()}?`,
            icon: "warning",
            dangerMode: true,
            buttons: ["Отмена", "Удалить"],
        }).then(async (willDelete) => {
            if (willDelete) {
                const result = await dispatch(deleteReceipe(activeReceipe.id, 'semi'));
                if (result) setActiveReceipe(result[0]);
            }
        });
    };

    const renderTable = (recipes, title, buttons) => (
        <div className="kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--loaded">
            <table className="kt-datatable__table" style={{ width: '100%' }}>
                <thead className="kt-datatable__head">
                <tr className="kt-datatable__row">
                    <th colSpan="3" className="kt-datatable__cell kt-datatable__title">
                        {title}
                    </th>
                    {buttons && <th>
                        {renderButtons()}
                    </th>}
                </tr>
                <tr className="kt-datatable__row">
                    <th width="145px" className="kt-datatable__cell kt-datatable__cell--sort">
                        <span>Наименование</span>
                    </th>
                    <th width="auto" className="kt-datatable__cell kt-datatable__cell--sort">
                        <span style={{ textAlign: 'left' }}></span>
                    </th>
                    <th width="145px" className="kt-datatable__cell kt-datatable__cell--sort">
                        <span style={{ textAlign: 'center' }}>Количество</span>
                    </th>
                </tr>
                </thead>
                <tbody className="kt-datatable__body">
                {recipes.map((item) => (
                    <tr key={item.id} className="kt-datatable__row">
                        <td width="145px" className="kt-datatable__cell">{item.name || 'DELETED'}</td>
                        <td align="left" width="auto" className="kt-datatable__cell">{MEASURES_RAW[item.measure] || ''}</td>
                        <td align="center" width="145px" className="kt-datatable__cell">{parseNumToFixed(item.quantity.default, 3)}</td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );

    const renderDateTabs = () => (
        <div className="inner-date-tabs" style={{ marginBottom: '1rem' }}>
            <ul className="nav nav-tabs nav-tabs-space-lg nav-tabs-line nav-tabs-bold nav-tabs-line-3x nav-tabs-line-brand">
                {detail.recipes.map((recipe) => (
                    <li key={recipe.id} className="nav-item">
                        <button
                            onClick={() => setActiveReceipe(recipe)}
                            className={`nav-link ${(activeReceipe && recipe.id === activeReceipe.id) ? 'active' : ''}`}
                        >
                            {formatDateTime(recipe.startDate)}
                        </button>
                    </li>
                ))}
            </ul>
        </div>
    );

    const renderButtons = () => {
        return (
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                <button
                    onClick={onOpenEditRecipe}
                    title={'Редактировать'}
                    disabled={loading}
                    className={"btn btn-sm btn-icon btn-icon-md btn-primary"}>
                    <i className="flaticon2-contract"></i>
                </button>
                <button
                    onClick={handleDelete}
                    title={'Удалить'}
                    disabled={loading}
                    className={"btn btn-sm btn-icon btn-icon-md btn-danger"}>
                    <i className="la la-trash"></i>
                </button>
            </div>
        );
    };

    const renderName = (item, type) => {
        let categoryText;

        if (type === 'good') {
            categoryText = (item.category && item.category.title) ? item.category.title : null;
        } else {
            categoryText = (item.productscategory && item.productscategory.title) ? item.productscategory.title : null;
        }

        return categoryText ? `${categoryText}: ${item.name || `Наименование продукта id ${item.id} не определено`}` : item.name || `Наименование продукта id ${item.id} не определено`;
    }

    const getIngredients = (ingredients) => {
        if (!ingredients) return null;
        const result = ingredients.map((ingredient) => {
            let entity = null;
            if (ingredient.type === 'good') {
                entity = goods.find((good) => good.id === ingredient.id);
                entity.measure = 'pc';
            } else {
                entity = raws.find((raw) => raw.id === ingredient.id);
            }
            return { ...ingredient, name: renderName(entity, ingredient.type), measure: entity.measure };
        });
        return result;
    }
    
    const renderContentForActiveDate = () => {
        if (!activeReceipe) return;
        const ingredients = getIngredients(activeReceipe.ingredients);

        const groups = ingredients ? ingredients.reduce((acc, i) => {
            acc[i.type] = [...(acc[i.type] || []), i];
            return acc;
        }, {}) || {} : {};
        
        const { raw: raws = [], semi: semis = [], good: goods = [] } = groups;
        
        return (
            <div>
                {renderDateTabs()}
                {raws.length <= 0 && semis.length <= 0 && goods.length <= 0 && <button
                    onClick={handleDelete}
                    title={'Удалить'}
                    disabled={loading}
                    className={"btn btn-sm btn-icon btn-icon-md btn-danger"}>
                    <i className="la la-trash"></i>
                </button>}
                {detail && !isEmpty(detail.modifications) && <h4 style={{ color: "black", paddingLeft: '25px' }}>По умолчанию</h4>}
                {raws.length > 0 && renderTable(raws, 'Сырье', 'default', true)}
                {semis.length > 0 && renderTable(semis, 'Полуфабрикаты', 'default', raws.length <= 0)}
                {goods.length > 0 && renderTable(goods, 'Товары', 'default', raws.length <= 0 && semis.length <= 0)}
            </div>
        );
    };

    return (
        <>
            {loading ? (
                <div style={styles.loading}><Loader /></div>
            ) : (
                <>
                    <div className="kt-portlet__body" style={{ minHeight: '350px', padding: '1rem' }}>
                        {!isEmpty(detail.recipes) ? (
                            renderContentForActiveDate()
                        ) : (
                            <div style={{ padding: '20px' }}>
                                <InfoBox
                                    title="Ингредиенты"
                                    subtitle="Для товара нет ингредиентов"
                                />
                            </div>
                        )}
                    </div>
                </>
            )}
        </>
    );
}
